import Model from './Model'

export default class ExerciseCategory extends Model {
  resource() {
    return 'exercise/categories'
  }
}
